"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProviderNew = void 0;
const react_1 = __importStar(require("react"));
const DesignSystem_1 = require("./..");
const themeParser_1 = require("../helpers/themeParser");
const ThemeProviderNew = ({ theme, children, parentRef }) => {
    const [themeStyles, setThemeStyles] = (0, react_1.useState)((0, themeParser_1.themeParser)(theme));
    (0, react_1.useLayoutEffect)(() => {
        setThemeStyles((0, themeParser_1.themeParser)(theme));
    }, [theme]);
    (0, react_1.useLayoutEffect)(() => {
        const getRoot = () => {
            if (parentRef instanceof HTMLElement) {
                return parentRef;
            }
            if (parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) {
                return parentRef.current;
            }
            return document.documentElement;
        };
        const root = getRoot();
        Object.keys(themeStyles).forEach((key) => {
            root.style.setProperty(key, themeStyles[key]);
        });
        return () => {
            Object.keys(themeStyles).forEach((key) => {
                root.style.removeProperty(key);
            });
        };
    }, [parentRef, theme, themeStyles]);
    return react_1.default.createElement(DesignSystem_1.UIContext.Provider, { value: { uiType: theme.uiType } }, children);
};
exports.ThemeProviderNew = ThemeProviderNew;
//# sourceMappingURL=ThemeProvider.js.map